import { render, staticRenderFns } from "./role-menus.vue?vue&type=template&id=008359ff&"
import script from "./role-menus.vue?vue&type=script&lang=js&"
export * from "./role-menus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports